module.exports = __webpack_public_path__ + "img/streampac-logo-white.b00b0445.svg";